<script>

import moment from 'moment';
import { http } from '@/system/http';
import DanishSystemsSurvey from "@/system/components/updateNotification/DanishSystemsSurvey";
import ContentComponent from '@/system/components/global/updates/ContentComponent';

export default {
    data: function(){
        return {
            current_message: false,
            messageLoading: false,
            notifications : this.initial_notifications,
            step: 0,
            contentComponent: ''
        }
    },

    props: {
        initial_notifications: {
            type: Array,
            default: () => { return [] }
        }
    },

    mounted: function() {
        if (this.notifications.length) {
            this.fetchNotificationContent().then(() => {
                this.showMessage();
                $('#update-notification-modal').modal('show');
            }).catch(() => {});
        }
    },

    methods: {
        closeModal() {
            http.post('/app/update-notification/mark-all-read');
            $('#update-notification-modal').modal('hide');
        },

        fetchNotificationContent() {
            var data = this.notifications.map((notification) => {
                return notification.id;
            });

            return http.get('/app/update-notification', {
                params: {
                    ids: data,
                }
            }).then(({ data }) => {
                this.notifications = data;
            }).catch(() => {});
        },

        nextMessage(){
            if (!this.messageLoading && this.step < (this.notifications.length) - 1){
                this.messageLoading = true;
                setTimeout(this.stepForward, 500);
            }
        },

        previousMessage(){
            if (!this.messageLoading && this.step > 0) {
                this.messageLoading = true;
                setTimeout(this.stepBackward, 500);
            }
        },

        showMessage() {
            this.current_message = this.notifications[this.step];
            this.messageLoading = false;

            if (this.current_message.template == 'add_payment_card') {
                $('.update-notification-navigation').css('display', 'none');
            }

          if (this.current_message.template == 'da_external_services_survey_denmark') {
            this.contentComponent = "DanishSystemsSurvey";
          } else {
            this.contentComponent = "ContentComponent";
          }

            http.post('/app/update-notification/' + this.current_message.id + '/mark-read');
        },

        stepBackward() {
            this.step--;
            this.showMessage();
        },

        stepForward() {
            this.step++;
            this.showMessage();
        },
    },

    computed: {
        current_message_date() {
            return moment(this.notifications[this.step].date).locale(moment_locale).format('LL');
        },

        hide_message() {
            return !this.current_message || this.messageLoading;
        },

        show_next_button() {
            return this.step < this.notifications.length - 1;
        },
    },

  components: {
    DanishSystemsSurvey,
    ContentComponent
  }
};
</script>

<template id="global-notification">
    <div class="update-notification">
        <div class="modal-dialog modal-lg">
            <div class="panel panel-color panel-inverse m-0">
                <div class="panel-heading">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click.prevent="closeModal()">×</button>
                    <h3 class="panel-title truncate" v-if="current_message"><i class="zmdi zmdi-refresh m-r-10"></i>{{ trans('update_notification.title') }}</h3>
                </div>
            </div>

            <div class="modal-content" :class="{ 'hide-message' : hide_message, 'show-message' : !hide_message }">

                <!-- Messages Inserted Here, see template in resources > views > system > update_notice > examples -->
                <div :class="{ 'hide-message' : hide_message, 'show-message' : !hide_message }">

                    <p class="text-muted">{{ current_message_date }}</p>

                    <component
                        :is="contentComponent"
                        :rendered_content="current_message.rendered_content"
                    ></component>

                </div>

                <div class="update-notification-navigation clearfix" :class="{ 'm-t-20' : show_next_button || step > 0 }">

                    <div class="row">
                        <div class="col-xs-6">

                            <a href="" class="previous btn btn-custom btn-trans " :class="{ 'hide-message' : hide_message, 'show-message' : !hide_message }" @click.prevent="previousMessage()" :disabled="hide_message" v-show="step > 0">
                                <i class="zmdi zmdi-arrow-left m-r-5"></i>
                                <span>{{ trans('global.back') }}</span>
                            </a>

                        </div>
                        <div class="col-xs-6 text-right">

                            <a href="" v-show="show_next_button" class="m-l-10 next btn btn-custom"  :class="{ 'hide-message' : hide_message, 'show-message' : !hide_message }" @click.prevent="nextMessage()" :disabled="hide_message" >
                                <span>{{ trans('global.next') }}</span>
                                <i class="zmdi zmdi-arrow-right m-l-5"></i>
                            </a>

                        </div>
                    </div>

                </div>

                <p class="m-t-10 m-b-0 text-muted text-center"><small>{{ trans('app.goto_updates_overview') }} <a href="/app/updates">"{{ trans('app.updates') }}"</a></small></p>

            </div>

        </div>
    </div>
</template>

